import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Monitor, Smartphone, Download, ShieldCheck } from "lucide-react";
import { useSettings } from "../context/SettingsContext";

export default function BuyNowModal({ open, onClose, course }) {
  const { settings } = useSettings();

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent
        data-testid="buy-now-modal"
        className="bg-[#0F1319] border border-amber-400/30 max-w-md text-white"
      >
        <DialogHeader>
          <div className="mx-auto mb-2 w-14 h-14 rounded-2xl bg-gradient-to-br from-[#E50914] to-[#F59E0B] flex items-center justify-center btn-gold-glow">
            <Download size={26} className="text-white" />
          </div>
          <DialogTitle className="font-display text-2xl text-center">
            Start Learning on <span className="gold-text">Aducation App</span>
          </DialogTitle>
          <DialogDescription className="text-center text-slate-400 text-sm">
            {course
              ? <>Download our app to purchase & watch <span className="text-amber-300 font-medium">"{course.title}"</span></>
              : "Download our app to purchase & watch all courses"
            }
          </DialogDescription>
        </DialogHeader>

        <div className="grid grid-cols-2 gap-3 mt-2">
          <a
            data-testid="modal-download-windows"
            href={settings.windows_download_url}
            target="_blank"
            rel="noreferrer"
            className="flex flex-col items-center gap-2 p-5 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 hover:border-amber-400/50 transition group"
          >
            <Monitor size={32} className="text-amber-400 group-hover:scale-110 transition" />
            <div className="text-sm font-semibold">Windows</div>
            <div className="text-[10px] text-slate-500 uppercase tracking-wider">.exe Installer</div>
          </a>
          <a
            data-testid="modal-download-android"
            href={settings.android_download_url}
            target="_blank"
            rel="noreferrer"
            className="flex flex-col items-center gap-2 p-5 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 hover:border-red-400/50 transition group"
          >
            <Smartphone size={32} className="text-red-400 group-hover:scale-110 transition" />
            <div className="text-sm font-semibold">Android</div>
            <div className="text-[10px] text-slate-500 uppercase tracking-wider">.apk File</div>
          </a>
        </div>

        <div className="mt-4 flex items-center justify-center gap-1.5 text-xs text-emerald-400">
          <ShieldCheck size={13} /> Safe & Verified · Register in app & Buy Now
        </div>
      </DialogContent>
    </Dialog>
  );
}
